import * as common from './common.json';

export const hi = {
  common,
};
